export default {
      id: "plus-usage",
      viewBox: "0 0 16 16",
      url: "../../assets/" + "sprite.svg#plus-usage",
      toString: function () {
        return this.url;
      }
    }